<template>
  <div>
    <div class="pt-6 lg:pb-0 lg:pl-6 xl:pl-6 md:pl-6" v-if="windowResize.width > 200">
      <div class="flex flex-wrap w-full p-4 hidden md:hidden lg:block">
        <div class="not-italic font-normal text-zt-xl leading-8 flex items-center" :class="textColorClass">
          {{ $t('message.LicensesManager.landing.title') }}
        </div>
      </div>
      <div class="flex w-full p-4 md:flex-row flex-col content-div">
        <v-hover>
          <template v-slot="{ hover }">
            <v-card flat :elevation="hover ? 10 : 1"
              class="rounded top-card-width cursor-pointer flex md:flex-row flex-col pb-16 mr-2 items-center md:items-start"
              @click="$router.push({ name: 'licensesSearch', params: { routerGo: 'manager' } })" data-vs-button="toLicensesSearch">
              <div class="md:w-5/12 text-center pt-10 md:pt-24">
                <div class="w-full md:ml-4">
                  <graphic-base :viewBox="'0 0 157 144'" class="mx-auto graphic-size">
                    <LicensesRequestSVG />
                  </graphic-base>
                </div>
              </div>
              <div class="md:w-6/12 px-2 md:pt-16 text-center md:text-left">
                <div class="md:pl-4 text-zt-lg md:text-zt-xl text-zt-dark-600 md:text-zt-dark-400">
                  {{
                    $t('message.LicensesManager.landing.title_licenses_search')
                  }}
                </div>
                <div class="md:pl-4 text-zt-lg text-zt-dark-300 margin-top md:w-11/12 padding-inline">
                  {{
                    $t(
                      'message.LicensesManager.landing.subtitle_licenses_search'
                    )
                  }}
                </div>
              </div>
              <div class="w-1/12 pt-40 hidden md:hidden lg:block">
                <zt-icon name="angle-right-solid" />
              </div>
            </v-card>
          </template>
        </v-hover>
        <v-hover>
          <template v-slot="{ hover }">
            <v-card flat :elevation="hover ? 10 : 1"
              class="rounded top-card-width cursor-pointer flex md:flex-row flex-col pb-16 items-center md:items-start"
              @click="$router.push({name: 'pendingApproval', params: { routerGo: 'manager' } })" data-vs-button="toPendingApproval">
              <div class="md:w-5/12 text-center pt-10 md:pt-24">
                <div class="w-full md:ml-4">
                  <graphic-base :viewBox="'0 0 157 144'" class="mx-auto graphic-size">
                    <LicensesClockSVG />
                  </graphic-base>
                </div>
              </div>
              <div class="md:w-6/12 px-2 md:pt-16 text-center md:text-left">
                <div class="md:pl-4 text-zt-lg md:text-zt-xl text-zt-dark-600 md:text-zt-dark-400">
                  {{ $t('message.LicensesManager.landing.title_pending') }}
                </div>
                <div class="md:pl-4 text-zt-lg text-zt-dark-300 margin-top md:w-11/12 padding-inline">
                  {{ $t('message.LicensesManager.landing.subtitle_pending') }}
                </div>
                <div class="md:pl-4 text-zt-dark-500 mt-10" v-if="showInfo">
                  <span class="text-zt-lg">{{
                    $t('message.LicensesManager.landing.info_pending1', {
                      pendingLicenses
                    })
                  }}</span><br />
                  <span class="text-zt-md">{{
                    $t('message.LicensesManager.landing.info_pending2')
                  }}</span>
                </div>
              </div>
              <div class="w-1/12 pt-40 hidden md:hidden lg:block">
                <zt-icon name="angle-right-solid" />
              </div>
            </v-card>
          </template>
        </v-hover>
      </div>
      <div class="flex w-full p-2 hidden md:hidden lg:flex p-4">
        <v-hover>
          <template v-slot="{ hover }">
            <v-card v-if="permissionOnButton('91')" flat :elevation="hover ? 10 : 1"
              class="rounded bottom-card-width cursor-pointer mr-4 flex-1" @click="$router.push({name:'licensesBalances', params: { routerGo: 'manager' } })" data-vs-button="toLicensesBalance">
              <div class="flex flex-wrap">
                <div class="bg-white rounded-zt-sm flex flex-col items-center justify-center w-11/12 my-8">
                  <div class="icon-size" :class="textColorClass">
                    <zt-icon name="calendar" />
                  </div>
                  <div class="mt-4 text-zt-lg text-zt-dark-400">
                    <span>{{
                      $t('message.LicensesManager.landing.title_balances')
                    }}</span>
                  </div>
                  <div class="mt-2 w-2/3 text-center">
                    <span class="text-zt-md text-zt-dark-300">
                      {{
                        $t('message.LicensesManager.landing.subtitle_balances')
                      }}
                    </span>
                  </div>
                </div>
                <div class="w-1/12 pt-24">
                  <zt-icon name="angle-right-solid" />
                </div>
              </div>
            </v-card>
          </template>
        </v-hover>
        <v-hover>
          <template v-slot="{ hover }">
            <v-card flat :elevation="hover ? 10 : 1" class="rounded bottom-card-width cursor-pointer mr-4 flex-1"
              @click="$router.push({ name:'licensesHolidays', params: { routerGo: 'manager' }})" v-if="permissionOnButton('92')" data-vs-button="toLicensesHoliday">
              <div class="flex flex-wrap">
                <div class="bg-white rounded-zt-sm flex flex-col items-center justify-center w-11/12 my-8">
                  <div class="icon-size" :class="textColorClass">
                    <zt-icon name="palm-tree" />
                  </div>
                  <div class="mt-4 text-zt-lg text-zt-dark-400">
                    <span>{{
                      $t('message.LicensesManager.landing.title_nonworkingdays')
                    }}</span>
                  </div>
                  <div class="mt-2 w-2/3 text-center">
                    <span class="text-zt-md text-zt-dark-300">
                      {{
                        $t(
                          'message.LicensesManager.landing.subtitle_nonworkingdays'
                        )
                      }}
                    </span>
                  </div>
                </div>
                <div class="w-1/12 pt-24">
                  <zt-icon name="angle-right-solid" />
                </div>
              </div>
            </v-card>
          </template>
        </v-hover>
        <v-hover>
          <template v-slot="{ hover }">
            <v-card flat :elevation="hover ? 10 : 1" class="rounded bottom-card-width cursor-pointer flex-1"
              @click="$router.push({ name: 'pendingApproval', params: { showPendingProp: 2, routerGo:'manager' } })" data-vs-button="toPendingApproval">
              <div class="flex flex-wrap">
                <div class="bg-white rounded-zt-sm flex flex-col items-center justify-center w-11/12 my-8">
                  <div class="icon-size" :class="textColorClass">
                    <zt-icon name="calendar-day" />
                  </div>
                  <div class="mt-4 text-zt-lg text-zt-dark-400">
                    <span>{{
                      $t(
                        'message.LicensesManager.managerLicense.title_calendar'
                      )
                    }}</span>
                  </div>
                  <div class="mt-2 w-2/3 text-center">
                    <span class="text-zt-md text-zt-dark-300">
                      {{
                        $t(
                          'message.LicensesManager.managerLicense.subtitle_calendar'
                        )
                      }}
                    </span>
                  </div>
                </div>
                <div class="w-1/12 pt-24">
                  <zt-icon name="angle-right-solid" />
                </div>
              </div>
            </v-card>
          </template>
        </v-hover>
      </div>
    </div>
    <div v-else>
      <RedirectFromManager />
    </div>
  </div>
</template>

<script>
import graphicBase from '@/components/commons/Illustrations/graphicBase'
import LicensesRequestSVG from '@/components/commons/Illustrations/graphicSVG/licensesRequestManager.vue'
import LicensesClockSVG from '@/components/commons/Illustrations/graphicSVG/LicensesClockSVG'
import Licenses from '@/apiClient/Licenses'
import { mapGetters, mapActions, mapState } from 'vuex'
import { useWindowResize } from '@sichern/ui-elements'
import RedirectFromManager from './RedirectFromManager'

export default {
  name: 'LicensesManagerPage',
  components: {
    graphicBase,
    LicensesRequestSVG,
    LicensesClockSVG,
    RedirectFromManager
  },
  data() {
    return {
      licenses: Licenses,
      pendingLicenses: 0,
      showInfo: false,
      windowResize: useWindowResize(this)
    }
  },
  computed: {
    ...mapGetters({
      getUser: 'getUser'
    }),
    ...mapState('licenses', ['pendingApproval']),
    isInIframe() {
      return window.self !== window.top;
    },
    textColorClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    }
  },
  created() {
    window.scrollTo(0, 0);
    this.fetchPendingApproval();
    this.showInfo = true;
  },
  methods: {
    ...mapActions('licenses', ['setPendingApproval']),
    permissionOnButton(id) {
      const actions = this.$store.state.actions;
      return actions && actions.length > 0 ? actions.some(act => act.id === id) : false;
    },

    async fetchPendingApproval() {
      const idUser = this.getUser.id;
      await this.setPendingApproval({ idUser });
      this.pendingLicenses = this.pendingApproval.length;
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-size {
  font-size: 2.5rem;
}

.text-iframe-primary {
  color: #2694fc !important;
}

@media screen and (min-width: 600px) {
  .top-card-width {
    width: 45%;
  }

  .graphic-size {
    height: 80%;
    width: 80%;
  }

  .margin-top {
    margin-top: 2.5rem;
  }
}

@media screen and (max-width: 769px) {
  .top-card-width {
    width: 95%;
    margin-left: 0.5rem;
  }

  .graphic-size {
    height: 60%;
    width: 60%;
  }

  .content-div {
    gap: 20px;
  }

  .margin-top {
    margin-top: 1rem;
  }

  .padding-inline {
    padding: 0 2rem;
  }
}

.bottom-card-width {
  width: 32%;
}
</style>
